import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiLogOut } from 'react-icons/fi';
import { TbChevronDown } from 'react-icons/tb';
import OutsideClickHandler from 'react-outside-click-handler';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '@/contexts/auth';

import { Typography } from '@/components/atoms/Typography';

export const NavbarSubMenuItem = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { user, clearUser } = useAuthContext();

  const onLogout = () => {
    queryClient.removeQueries();
    clearUser();
    navigate('/login');
  };

  const subMenu = [
    {
      label: t('subMenu.signOut'),
      onClick: onLogout,
      icon: <FiLogOut size={20} />
    }
  ];

  return (
    <div className="flex flex-col md:flex-row md:gap-8 gap-2 items-center">
      {user && user.isSupport && (
        <div className="bg-black px-3 py-1 rounded-md w-full">
          <Typography color="white">Connecté(e) en tant que support</Typography>
        </div>
      )}
      <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
        <div className="relative md:inline-block text-left">
          {user && (
            <div>
              <button
                type="button"
                className="inline-flex items-center justify-start md:justify-center md:px-4 md:py-2 md:text-sm font-normal md:font-medium text-black md:text-white border-none md:border md:border-solid rounded-md"
                id="options-menu"
                aria-expanded="true"
                aria-haspopup="true"
                onClick={() => {
                  setIsMenuOpen(!isMenuOpen);
                }}
              >
                {user.email}
                <TbChevronDown className={`h-3 w-3 ml-1 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
              </button>
            </div>
          )}
          {isMenuOpen && (
            <div
              className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-[1001]"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {subMenu.map((menu, index) => (
                <div key={index} className="py-1" role="none">
                  <button
                    className="flex flex-row px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
                    role="menuitem"
                    onClick={menu.onClick}
                  >
                    <div className="mr-3 flex-shrink-0">{menu.icon}</div>
                    <div className="flex flex-row ">{menu.label}</div>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
};
